module.exports = globalThis